export default __webpack_public_path__ + "static/media/daynapineda.9e0b00f3.jpg";